import { useState, useEffect, useMemo } from "react";
import { FetchDataTypes, MetaDataList, DeleteNewMeta } from "../../api/api";
import Cookies from "js-cookie";
import { AgGridReact } from "ag-grid-react";
import { GridReadyEvent } from "ag-grid-community";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Container, Offcanvas, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button } from "../../components/Button/Button";



const ProcessList = () => {
    const [metaList, setMetaList] = useState([]);
    const [show, setShow] = useState(false);
    const [showModel, setShowModel] = useState(false)
    const [selectedMetaID, setSelectedMetaID] = useState<any>(null)
    // get metadata list
    useEffect(() => {
        MetaDataList(Cookies.get("newJwt"))
          .then((response) => response?.json())
          .then((response) => {
            setMetaList(response);
            console.log(response.filter((item:any) => item.spName === "GetAPIData"));
          })
          .catch((error) => {
            console.error(error);
          });
      }, [MetaDataList]);

    // actions
    function editData(data:any){
        setShow(true)

    }
    function deleteData(data:any){
        setSelectedMetaID(data.data)
        console.log(data)
        setShowModel(true);
    }
    console.log(selectedMetaID)
    // slider control
    const closeSidebar = () => {
        setShow(false);
        // setResponse(null);
        // setSelectUser(null);
        // setUpdateResponse(null);
        //refetch();
      };
      const handleClose = () => {
        setShowModel(false);
      };
      const handleChangeUnlock = () => {
        const id = selectedMetaID.id;
        DeleteNewMeta(id, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
            response.errors
            ? toast.error("Error Deleting Process !", {
                position: toast.POSITION.TOP_RIGHT,
              })
            : toast.success("Deleted Successfully!", {
                position: toast.POSITION.TOP_RIGHT,
              });
          console.log(response.filter((item:any) => item.spName === "GetAPIData"));
        })
        .catch((error) => {
            toast.error("Error Deleting Process !", {
                position: toast.POSITION.TOP_RIGHT,
              })
          console.error(error);
        });
      }
// create columns
const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      refreshCells: true,
      //flex:1
    }),
    []
  );
  const [columns, setColumns] = useState([
    {
      headerName: "Name",
      field: "name",
      flex:1
    },
    {
      headerName: "SP Name",
      field: "spName",
      sortable: true,
      width: 250,
      
    },
    {
      headerName: "Description",
      field: "description",
      width: 250,
    },
    {
        headerName: "Actions",
        field: "",
        cellClass: "text-start",
        width: 85,
        cellRendererFramework: (params: any) => {
          return (
            <>
              <span
                onClick={() => editData({ data: params.data })}
                className="cursor-pointer"
              >
                <i title="edit" className="fas fa-fw fa-edit"></i>
              </span>
              <span
                onClick={() => deleteData({ data: params.data })}
                className="cursor-pointer ml-4"
              >
                <i title="delete" className="fas fa-fw fa-trash"></i>
              </span>
            </>
          );
        },
      },
  ]);
  console.log(metaList)
  return (
    <div>
         <Container className="">
        <div
          className="ag-theme-alpine"
          style={{
            height: "500px",
            width: "100%",
          }}
        >
        <AgGridReact
            rowData={metaList}
            columnDefs={columns}
            defaultColDef={defColumnDefs}
            animateRows={true}
            popupParent={document.body}
            pagination={true}
            paginationPageSize={20}
          ></AgGridReact>
</div>
<Offcanvas
              backdrop="false"
              placement="end"
              show={show}
              onHide={closeSidebar}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Create User</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                side slider
              </Offcanvas.Body>
            </Offcanvas>
          </Container>
          <Modal
        show={showModel}
        onHide={handleClose}
        centered
        className="modelComponent"
      >
        <Modal.Header closeButton>
          <Modal.Title>
          Meta data
            
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you Sure, You want to Delete Meta data
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            className="btn-primary"
            size="btn-xs"
            children="Close"
            onClick={handleClose}
          />
          
          
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Delete"
              onClick={handleChangeUnlock}
            />
         
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export {ProcessList}